import React from 'react';
import { observer } from 'mobx-react';

import { localeFormattedPrice } from 'common/utils';
import facility from 'app/facility';
import { HeaderContainer, Heading, PaymentAmount } from './styles/_header';
import form from 'modules/ticketPublicPage/stores/vouchers/form';

const Header = observer(() => {
  const { settings, languageCode } = facility;
  const { logo, currency } = settings;
  const { formValues, step, PAYMENT_DETAILS } = form;

  const isPaymentPage = step === PAYMENT_DETAILS;

  return (
    <HeaderContainer paymentPage={isPaymentPage}>
      {logo && <img src={logo} />}
      <Heading missingLogo={!logo}>{i18n.gettext('Vouchers')}</Heading>
      {isPaymentPage && (
        <PaymentAmount>
          {localeFormattedPrice(formValues.get('price'), {
            languageCode: languageCode,
            currencyCode: currency,
          })}
        </PaymentAmount>
      )}
    </HeaderContainer>
  );
});
export default Header;
